import React, { useRef, useState } from "react";
import { createPortal } from "react-dom";
import { AlertCircle } from "lucide-react";

export default function DashboardPortalTooltip({ text }) {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);

  const handleMouseEnter = () => {
    if (!triggerRef.current) return;
    const rect = triggerRef.current.getBoundingClientRect();
    setPosition({
      top: rect.top - 10,
      left: rect.left + rect.width / 2,
    });
    setVisible(true);
  };

  return (
    <>
      <div
        ref={triggerRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setVisible(false)}
        className="group relative inline-flex items-center ml-1 align-middle z-50 pointer-events-auto cursor-help text-gray-400 hover:text-[#354F38] transition-colors"
      >
        <AlertCircle size={14} />
      </div>
      {visible && createPortal(
        <div
          className="fixed z-[99999] pointer-events-none"
          style={{ top: position.top, left: position.left }}
        >
          <div className="relative -translate-x-1/2 -translate-y-full mb-2 bg-[#354F38]/95 backdrop-blur-md text-white text-xs font-bold px-4 py-2.5 rounded-xl shadow-2xl border border-white/20 whitespace-pre-wrap leading-relaxed min-w-[180px] text-center">
            {text}
            <div className="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-[#354F38]/95"></div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
